import { PLAUSIBLE_EVENTS } from './consts'

export function firePlausibleEvent(eventName: PLAUSIBLE_EVENTS, payload: any = {}) {
  if (window?.plausible) {
    window.plausible(eventName, payload)
  }
}
